import { msSessionStorage } from '@common/utils/cache';

export const oldVersionProxy = (result, title) => {
  // 递归为实体表格增加响应拦截
  const defineProperty = (_table) => {
    for (const key in _table) {
      let curVal = _table[key];
      if (typeof curVal === 'object') {
        defineProperty(curVal);
      }
      Object.defineProperty(_table, key, {
        get() {
          return curVal;
        },
        set(newVal) {
          if (_table[key] === newVal) return;
          curVal = newVal;
          // 每次内容变化，需要将表格内容存至缓存中
          // 由于整体监听，所以只有在非函数赋值时才做缓存，后面需要优化
          if (typeof _table[key] !== 'function') {
            const cacheTable = {};
            for (const key in result) {
              if (typeof result[key] !== 'function') {
                cacheTable[key] = result[key];
              }
            }
            Promise.resolve().then(() => msSessionStorage.set(title, cacheTable));
          }
        },
      });
    }
  };

  defineProperty(result);
};
